import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Phone, MessageCircle, CheckCircle } from 'lucide-react';
import { Button } from './ui/button';
import Header from './Header';
import Footer from './Footer';
import FloatingWhatsApp from './FloatingWhatsApp';

const IdraulicoRomaPrati = () => {
  const handleCall = () => window.location.href = 'tel:3287686356';
  const handleWhatsApp = () => window.open('https://wa.me/393287686356?text=Ciao,%20ho%20bisogno%20di%20un%20idraulico%20urgente%20a%20Prati.', '_blank');

  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <>
      <Helmet>
        <title>Idraulico Prati Roma H24 - Arrivo in 60 Minuti | Tel 328 768 6356</title>
        <meta name="description" content="Idraulico Prati Roma H24. Arriviamo entro 60 minuti. Perdite acqua, scarichi, caldaie. Preventivo gratuito. Tel: 328 768 6356" />
        <link rel="canonical" href={`${window.location.origin}/idraulico-roma-prati`} />
      </Helmet>
      
      <div className="min-h-screen">
        <Header />
        
        <section className="bg-gradient-to-br from-orange-50 to-blue-50 py-12">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <div className="bg-orange-500 text-white px-6 py-3 rounded-lg inline-block font-bold mb-4 animate-pulse">
                🚨 INTERVENTO URGENTE PRATI
              </div>
              
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
                Idraulico Prati Roma
              </h1>
              
              <p className="text-2xl md:text-3xl font-bold text-orange-600 mb-6">
                ⚡ Arriviamo entro 60 minuti a Prati
              </p>
              
              <div className="bg-white p-6 rounded-lg shadow-xl mb-8">
                <p className="text-xl font-bold text-gray-900 mb-4">Problemi Risolti Oggi a Prati:</p>
                <div className="grid md:grid-cols-2 gap-3 text-left">
                  <div className="flex items-center gap-2"><CheckCircle className="text-green-500 h-5 w-5" /><span>Perdite acqua urgenti</span></div>
                  <div className="flex items-center gap-2"><CheckCircle className="text-green-500 h-5 w-5" /><span>Scarichi intasati</span></div>
                  <div className="flex items-center gap-2"><CheckCircle className="text-green-500 h-5 w-5" /><span>Rubinetti che perdono</span></div>
                  <div className="flex items-center gap-2"><CheckCircle className="text-green-500 h-5 w-5" /><span>Caldaie in blocco</span></div>
                  <div className="flex items-center gap-2"><CheckCircle className="text-green-500 h-5 w-5" /><span>WC intasato</span></div>
                  <div className="flex items-center gap-2"><CheckCircle className="text-green-500 h-5 w-5" /><span>Tubi scoppiati</span></div>
                </div>
              </div>
              
              <div className="flex flex-col gap-4 max-w-lg mx-auto">
                <Button onClick={handleWhatsApp} size="lg" className="bg-orange-500 hover:bg-orange-600 text-white text-2xl px-12 py-8 font-bold shadow-2xl animate-pulse">
                  <MessageCircle className="mr-3 h-8 w-8" />
                  SCRIVI SU WHATSAPP
                </Button>
                <Button onClick={handleCall} size="lg" className="bg-blue-700 hover:bg-blue-800 text-white text-xl px-10 py-7 font-bold">
                  <Phone className="mr-3 h-7 w-7" />
                  CHIAMA: 328 768 6356
                </Button>
              </div>
              
              <p className="mt-8 text-lg text-gray-700">
                <strong>Zone coperte:</strong> Prati, Trionfale, Balduina, Cipro, Ottaviano, Mazzini, Delle Vittorie, Borgo Pio
              </p>
            </div>
          </div>
        </section>

        <Footer />
        <FloatingWhatsApp />
      </div>
    </>
  );
};

export default IdraulicoRomaPrati;
